/**
 * Convert camelCase string to snake_case
 * @param {string} str - The string to convert
 * @returns {string} The converted string in snake_case
 */
export const camelToSnakeCase = (str) => {
  if (typeof str !== 'string') return str;
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

/**
 * Convert object keys from camelCase to snake_case
 * @param {Object} obj - The object to convert
 * @returns {Object} New object with snake_case keys
 */
export const convertKeysToSnakeCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(item => convertKeysToSnakeCase(item));
  }
  
  return Object.keys(obj).reduce((acc, key) => {
    const snakeKey = camelToSnakeCase(key);
    const value = obj[key];
    
    acc[snakeKey] = value && typeof value === 'object' 
      ? convertKeysToSnakeCase(value) 
      : value;
      
    return acc;
  }, {});
};
